export default [
  {
    path: '/active-springfestival2023/index',
    name: 'index',
    component: () => import('@/views/active-springfestival2023/index'),
    meta: {
      title: '2023钱兔似锦，集亮度开红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-springfestival2023/record',
    name: 'record',
    component: () => import('@/views/active-springfestival2023/record'),
    meta: {
      title: '2023钱兔似锦，集亮度开红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  },{
    path: '/active-springfestival2023/invite',
    name: 'invite',
    component: () => import('@/views/active-springfestival2023/invite'),
    meta: {
      title: '2023钱兔似锦，集亮度开红包-高考直通车',
      content:'虎年大吉，考神附体，快来瓜分红包蹭考运'
    }
  }
]
